<template>
  <div class="courseArranging">
    <div class="section">
      <el-page-header @back="goBack" content="批量排课"> </el-page-header>
      <el-row :gutter="20" style="margin-top: 20px">
        <el-col :span="17">
          <el-card shadow="never">
            <div>
              <el-form class="form-style" label-width="100px" size="mini">
                <el-form-item label="开课日期" required>
                  <el-date-picker
                    v-model="start_date"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    size="mini"
                    placement="bottom-start"
                  ></el-date-picker>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="勾选后,系统排课可自动跳过停课日"
                    placement="top-start"
                  >
                    <el-checkbox
                      v-model="is_stop_day"
                      style="margin-left: 30px; font-size: 14px"
                      >跳过停课日</el-checkbox
                    >
                  </el-tooltip>

                  <el-button
                    type="text"
                    size="mini"
                    style="float:right;font-size: 14px"
                    @click="addTime"
                    ><i class="el-icon-time"></i>添加上课时段
                  </el-button>
                  <el-button
                    type="text"
                    size="mini"
                    style="float:right;font-size: 14px;margin-right:10px;"
                    @click="settingCloseDay"
                  >
                    <i class="el-icon-setting"></i>设置停课日</el-button
                  >
                </el-form-item>
                <el-form-item> </el-form-item>
                <el-form-item label="上课星期" required>
                  <el-checkbox-group v-model="weekList">
                    <el-checkbox :label="99">每天</el-checkbox>
                    <el-checkbox :label="1" :disabled="!weekDisable"
                      >周一</el-checkbox
                    >
                    <el-checkbox :label="2" :disabled="!weekDisable"
                      >周二</el-checkbox
                    >
                    <el-checkbox :label="3" :disabled="!weekDisable"
                      >周三</el-checkbox
                    >
                    <el-checkbox :label="4" :disabled="!weekDisable"
                      >周四</el-checkbox
                    >
                    <el-checkbox :label="5" :disabled="!weekDisable"
                      >周五</el-checkbox
                    >
                    <el-checkbox :label="6" :disabled="!weekDisable"
                      >周六</el-checkbox
                    >
                    <el-checkbox :label="0" :disabled="!weekDisable"
                      >周日</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item v-show="weekDisable" label="上课时段" required>
                  <div
                    class="frame"
                    v-show="weekList.includes(1) && weekDisable"
                  >
                    <span class="title">周一</span>
                    <el-select
                      style="margin-left: 20px"
                      v-model="selectTime[1]"
                    >
                      <el-option
                        v-for="(item, index) in selectTimeList"
                        :key="index"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div
                    class="frame"
                    v-show="weekList.includes(2) && weekDisable"
                  >
                    <span class="title">周二</span>
                    <el-select
                      style="margin-left: 20px"
                      v-model="selectTime[2]"
                    >
                      <el-option
                        v-for="(item, index) in selectTimeList"
                        :key="index"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div
                    class="frame"
                    v-show="weekList.includes(3) && weekDisable"
                  >
                    <span class="title">周三</span>
                    <el-select
                      style="margin-left: 20px"
                      v-model="selectTime[3]"
                    >
                      <el-option
                        v-for="(item, index) in selectTimeList"
                        :key="index"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div
                    class="frame"
                    v-show="weekList.includes(4) && weekDisable"
                  >
                    <span class="title">周四</span>
                    <el-select
                      style="margin-left: 20px"
                      v-model="selectTime[4]"
                    >
                      <el-option
                        v-for="(item, index) in selectTimeList"
                        :key="index"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div
                    class="frame"
                    v-show="weekList.includes(5) && weekDisable"
                  >
                    <span class="title">周五</span>
                    <el-select
                      style="margin-left: 20px"
                      v-model="selectTime[5]"
                    >
                      <el-option
                        v-for="(item, index) in selectTimeList"
                        :key="index"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div
                    class="frame"
                    v-show="weekList.includes(6) && weekDisable"
                  >
                    <span class="title">周六</span>
                    <el-select
                      style="margin-left: 20px"
                      v-model="selectTime[6]"
                    >
                      <el-option
                        v-for="(item, index) in selectTimeList"
                        :key="index"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div
                    class="frame"
                    v-show="weekList.includes(0) && weekDisable"
                  >
                    <span class="title">周日</span>
                    <el-select
                      style="margin-left: 20px"
                      v-model="selectTime[0]"
                    >
                      <el-option
                        v-for="(item, index) in selectTimeList"
                        :key="index"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
                <el-form-item v-show="!weekDisable" label="时段" required>
                  <div class="time-frame" v-if="weekList.length">
                    <div class="frame" v-show="weekList.includes(99)">
                      <p class="title">每天</p>
                      <div class="time">
                        <el-select v-model="selectTime[99]">
                          <el-option
                            v-for="(item, index) in selectTimeList"
                            :key="index"
                            :label="item"
                            :value="item"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="排课周期" required>
                  <el-radio-group v-model="interval_num">
                    <el-radio :label="0">连续</el-radio>
                    <el-radio :label="1">隔一周</el-radio>
                    <el-radio :label="2">隔两周</el-radio>
                    <el-radio :label="3">隔三周</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form>
            </div>
            <div style="text-align: left" class="btn">
              <el-button
                size="small"
                type="primary"
                @click="bulkUpdateTeachingPlan"
                >修改排课</el-button
              >
            </div>
          </el-card>
        </el-col>
        <el-col :span="7">
          <el-card shadow="never">
            <div>
              已选讲次
              <span>{{ NotStartedCourse.length }}节</span>
              <span style="margin-left: 10px;"> (可拖动改变讲次顺序)</span>
              <el-table
                ref="multipleTable"
                size="mini"
                row-key="id"
                :data="NotStartedCourse"
                tooltip-effect="dark"
                style="width: 100%; margin-top: 20px"
                :header-cell-style="{ background: '#f5f7fa', color: '#909399' }"
                height="500px"
                @selection-change="handleSelectionPlan"
              >
                <el-table-column align="center" width="50" label="序号">
                  <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="讲次名称" class="bg">
                  <template slot-scope="scope">{{
                    scope.row.lessionInfo.title
                  }}</template>
                </el-table-column>
                <el-table-column align="center" width="150" label="操作">
                  <template slot-scope="scope">
                    <i
                      class="el-icon-delete"
                      style="cursor: pointer"
                      @click="DeleteNotStartedPlan(scope.row)"
                    ></i>
                    <i
                      class="el-icon-rank"
                      style="margin-left:20px; cursor: pointer;"
                    ></i>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-dialog
        class="dialog"
        title="设置停课日"
        :visible.sync="dialogVisible"
        width="560px"
        top="10vh"
      >
        <el-button
          type="text"
          style="margin-left: 20px"
          icon="el-icon-circle-plus"
          @click="addStopDay"
          v-if="!educational_institution_closing_day_list.length"
          >设置停课日</el-button
        >
        <div
          v-for="(item, index) of educational_institution_closing_day_list"
          :key="index"
          style="display: flex; margin: 10px"
        >
          <el-date-picker
            v-model="item.closing_date"
            type="date"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 200px"
            placement="bottom-start"
          ></el-date-picker>
          <el-input
            v-model="item.name"
            placeholder="请输入名称"
            style="width: 200px; margin-left: 20px"
          ></el-input>

          <el-button
            type="text"
            style="margin-left: 20px"
            icon="el-icon-remove"
            @click="reduceStopDay(index)"
          >
          </el-button>
          <el-button
            type="text"
            style="margin-left: 20px"
            icon="el-icon-circle-plus"
            @click="addStopDay"
            v-if="index === educational_institution_closing_day_list.length - 1"
          ></el-button>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            size="small"
            style="margin-left: 20px"
            @click="dialogVisible = false"
            >取消</el-button
          >
          <el-button size="small" type="primary" @click="saveStopDay"
            >保存</el-button
          >
        </span>
      </el-dialog>
      <!-- 设置上课时段 -->
      <el-dialog
        class="dialog"
        title="上课时段"
        :visible.sync="dialogVisibleTime"
        width="560px"
        top="10vh"
      >
        <ul>
          <li style="border-bottom: 1px solid #f2f2f2">
            <el-tooltip
              class="item"
              effect="dark"
              content="上课时段为校区排课的时间基准,请首先设置好常用的上课时段,然后再进行排课操作."
              placement="top"
            >
              <el-button
                type="text"
                style="margin-left: 0px"
                icon="el-icon-circle-plus"
                @click="addClassTime"
                >上课时段
              </el-button>
            </el-tooltip>
          </li>
          <li
            v-for="(item, index) of selectTimeList1"
            :key="index"
            style="
                  font-size: 14px;
                  border-bottom: 1px solid #f2f2f2;
                  padding-left: 10px;
                  box-sizing: border-box;
                "
          >
            <div v-if="item.edit" style="margin: 10px 0">
              <el-time-picker
                size="small"
                v-model="updateform1.start_time"
                placeholder="选择开始时间"
                value-format="HH:mm"
              >
              </el-time-picker>
              至
              <el-time-picker
                size="small"
                v-model="updateform1.end_time"
                placeholder="选择结束时间"
                value-format="HH:mm"
              >
              </el-time-picker>

              <el-button
                type="text"
                style="margin-left: 20px"
                @click="submitClassDay(index)"
                >确定</el-button
              >
              <el-button
                type="text"
                style="margin-left: 20px"
                @click="closeUpdateClassTime(index)"
                >取消</el-button
              >
            </div>
            <div v-else>
              {{ item.start_class_date }}~{{ item.end_class_date }}
              <el-button
                type="text"
                style="margin-left: 20px"
                @click="updateClassTime(index)"
                ><i class="el-icon-edit"></i
              ></el-button>
              <el-button
                type="text"
                style="margin-left: 20px"
                @click="deleteClassDay(index)"
                ><i class="el-icon-delete"></i
              ></el-button>
            </div>
          </li>
        </ul>
        <span slot="footer" class="dialog-footer">
          <el-button
            size="small"
            style="margin-left: 20px"
            @click="dialogVisibleTime = false"
            >关闭</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getBaseInfo,
  addStopDay,
  bulkUpdateTeachingPlan,
  addClassDay,
  updateIsEncryption,
} from '@/api/educational'
import Sortable from 'sortablejs'

export default {
  name: 'courseArranging',
  components: {},
  data() {
    return {
      tchPlanIdArr: [],
      dialogVisibleTime: false,
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible3: false,
      dialogVisible4: false,
      selectTime: {
        1: '',
        2: '',
        3: '',
        4: '',
        5: '',
        6: '',
        0: '',
        99: '',
      },
      updateform1: {
        start_time: '',
        end_time: '',
      },
      selectTimeList: [],
      selectTimeList1: [],
      weekList: [],
      educational_institution_closing_day_list: [],

      is_encryption: false,
      classtime: null,

      info: {},
      start_date: '',
      is_stop_day: false,
      interval_num: 0, //排课间隔周期
      if_ignore_conflict: 0, //默认检测冲突
      time_quantum: [],
      closing_day: [],
      teaching_plan_list: [{}],
      weekDisable: true,
      teacherDialog: false,
      teacherList: [],
      teaching_plan_id: '',
      timeDialog: false,
      openDate: '',
      updateSelectTime: '',
      editCourseShow: false,

      dialogFormVisible7: false, //修改讲次
      updateform: {
        title: '',
        lecturer_id: '',
        educational_institution_campus_id: '',
        class_date: '',
        value: [],
        teaching_plan_id: '',
        start_time: '',
        end_time: '',
      },
      form_teachplan: {
        teaching_plan_id: '', //讲次id
        add_num: 1, //顺延周数
        if_ignore_conflict: true, //默认检测冲突
      },

      form_insert: {
        teaching_plan_id: '', //讲次id
        tchplan_class_date: '', //上课日期
        tchplan_start_class_date: '', //开始时段
        tchplan_end_class_date: '', //结束时段
        value: null,
        if_ignore_conflict: 0, //默认检测冲突
        subject_id: '',
        campus_id: '',
      },

      form_time: {
        start_class_date: '', //开始时段
        end_class_date: '', //结束时段
        value: null,
      },
      educational_institution_class_day_list: [],

      choosePlanInfo: {
        title: '',
      }, // 调入讲次信息

      tchPlanIds: [], //删除的讲次id组
      tchPlanInfos: [], //选择的讲次

      curriculumMaterialList: [], //讲次列表
      SelectionPlan: [], //已选排课
      NotStartedCourse: [], //未上课讲次

      show_edit_plan: false, //显示重新排课页面

      SignStudents: [],
      current_teachplan_id: '',
    }
  },
  computed: {
    editPlan: function() {
      return !!this.teaching_plan_list.length
    },
  },
  watch: {
    NotStartedCourse(val) {
      let idArr = []
      val.map((item) => {
        console.log(item.id)
        idArr.push(item.id)
      })
      console.log(idArr, 154878)
      this.tchPlanIdArr = idArr
    },
    weekList: {
      handler(newValue) {
        if (newValue.includes(99)) {
          this.weekDisable = false
        } else {
          this.weekDisable = true
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getBaseInfo1()

    console.log(JSON.parse(sessionStorage.getItem('tchPlanInfos')), 4567897)
    this.NotStartedCourse = JSON.parse(sessionStorage.getItem('tchPlanInfos'))
    this.rowDrop()
  },
  methods: {
    // 行拖拽
    rowDrop() {
      // 要侦听拖拽响应的DOM对象
      const tbody = document.querySelector('.el-table__body-wrapper tbody')
      const that = this
      console.log(that.NotStartedCourse, 4547878)

      Sortable.create(tbody, {
        animation: 1000,
        ghostClass: 'ghostClass', //设置拖拽停靠样式类名
        chosenClass: 'chosenClass', //设置选中样式类名
        handle: '.el-icon-rank',
        // 结束拖拽后的回调函数
        onEnd({ newIndex, oldIndex }) {
          console.log('拖动了行，当前序号：' + newIndex)
          const currentRow = that.NotStartedCourse.splice(oldIndex, 1)[0]
          that.NotStartedCourse.splice(newIndex, 0, currentRow)
          console.log(that.NotStartedCourse, 4578)
        },
      })
    },
    getObject() {
      console.log('选中所有数据' + this.checked)
    },

    submitClassDay(index) {
      if (!this.updateform1.start_time) {
        this.$message.warning('请选择开始时间')
        return
      }

      if (!this.updateform1.end_time) {
        this.$message.warning('请选择结束时间')
        return
      }

      this.selectTimeList1[index].start_class_date = this.updateform1.start_time
      this.selectTimeList1[index].end_class_date = this.updateform1.end_time

      this.addClassDay('保存成功', 'update', index)
    },
    addClassDay(msg, status, index) {
      let class_day_list = this.selectTimeList1.map((item) => {
        return {
          start: '2020-02-02 ' + item.start_class_date,
          end: '2020-02-02 ' + item.end_class_date,
        }
      })

      console.log('添加的时段')
      console.log(class_day_list)

      class_day_list.sort(function(a, b) {
        return b.start > a.start ? -1 : 1
      })

      console.log('排序的时段')
      console.log(class_day_list)

      addClassDay({
        class_day_list: JSON.stringify(class_day_list),
      }).then(() => {
        if (status === 'update') {
          this.selectTimeList1[index].edit = false
          this.classtime = null
          console.log(this.classtime)
          this.getBaseInfo1()
        }
        this.$message.success(msg)
      })
    },
    deleteClassDay(index) {
      this.$confirm('确定删除当前授课时段?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.selectTimeList1.splice(index, 1)
        this.addClassDay('删除成功')
      })
    },
    closeUpdateClassTime(index) {
      console.log(index)
      this.$set(this.selectTimeList1[index], 'edit', false)
      this.classtime = null
      this.getBaseInfo1()
    },
    updateClassTime(index) {
      this.$set(this.selectTimeList1[index], 'edit', true)

      this.updateform1.start_time = this.selectTimeList1[index].start_class_date
      this.updateform1.end_time = this.selectTimeList1[index].end_class_date

      console.log(this.updateform1)
    },
    addTime() {
      this.dialogVisibleTime = true
    },
    addClassTime() {
      this.selectTimeList1.unshift({
        start_class_date: '',
        end_class_date: '',
        edit: true,
      })
    },
    updateIsEncryption() {
      updateIsEncryption({
        is_encryption: this.is_encryption,
      }).then(() => {
        this.$message.success('修改成功')
      })
    },
    getBaseInfo1() {
      getBaseInfo().then((res) => {
        this.educational_institution_closing_day_list =
          res.educational_institution_closing_day_list
        this.educational_institution_class_day_list =
          res.educational_institution_class_day_list

        console.log('学校上课时段')
        console.log(res.educational_institution_class_day_list)

        this.is_encryption = res.educational_institution_obj[0].is_encryption
        this.getBaseInfo()
      })
    },

    ShowPlan() {
      this.show_edit_plan = false
    },
    bulkUpdateTeachingPlan() {
      console.log('批量修改排课')

      if (!this.start_date) {
        this.$message.warning('请选择开课日期')
        return
      }
      this.time_quantum = []
      if (this.weekList.includes(99)) {
        this.weekList = [99]
      }
      for (let key of this.weekList) {
        this.time_quantum.push({
          type: key,
          start_date: this.selectTime[key].split('~')[0],
          end_date: this.selectTime[key].split('~')[1],
        })
      }
      if (!this.time_quantum.length) {
        this.$message.warning('请选择上课时段')
        return
      }
      for (let key of this.time_quantum) {
        if (!key.start_date) {
          this.$message.warning('请选择时间')
          return
        }
      }
      bulkUpdateTeachingPlan({
        classes_id: JSON.parse(sessionStorage.getItem('courseArranging')).id,
        start_date: this.start_date,
        is_stop_day: this.is_stop_day,
        interval_num: this.interval_num,
        time_quantum: JSON.stringify(this.time_quantum),
        closing_day: JSON.stringify(this.closing_day),
        if_ignore_conflict: this.if_ignore_conflict,
        tchPlanIdArr: JSON.stringify(this.tchPlanIdArr),
      }).then((res) => {
        console.log('批量修改排课')
        console.log(res)
        console.log(res.is_create)

        if (res.is_create === true) {
          this.$message.success('修改成功')
          this.goBack()
        } else {
          console.log('重复')
          this.$confirm(res.msg, '提示', {
            confirmButtonText: '忽略冲突',
            cancelButtonText: '取消排课',
            type: 'warning',
          })
            .then(() => {
              this.if_ignore_conflict = 1
              this.bulkUpdateTeachingPlan()
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '取消调课',
              })
              this.goBack()
            })
        }
      })
    },
    handleSelectionPlan(val) {
      console.log('已选讲次')
      console.log(val)
      this.SelectionPlan = val
    },

    cloneEditCourse() {
      this.start_date = ''
      this.weekList = []
      this.is_stop_day = false
      this.editCourseShow = false
    },

    settingCloseDay() {
      this.getBaseInfo()
      this.dialogVisible = true
    },

    settingTimes() {
      this.getBaseInfo()

      this.dialogVisible4 = true
    },

    saveStopDay() {
      for (
        let i = 0;
        i < this.educational_institution_closing_day_list.length;
        i++
      ) {
        if (
          !this.educational_institution_closing_day_list[i].closing_date ||
          !this.educational_institution_closing_day_list[i].name
        ) {
          this.$message.warning('请填写日期或名称')
          return
        }
      }
      let closing_day_list = this.educational_institution_closing_day_list.map(
        (item) => {
          return {
            date: item.closing_date,
            name: item.name,
          }
        }
      )
      addStopDay({
        closing_day_list: JSON.stringify(closing_day_list),
      }).then(() => {
        this.$message.success('保存成功')
        this.dialogVisible = false
      })
    },
    addStopDay() {
      this.educational_institution_closing_day_list.push({
        closing_date: '',
        name: '',
      })
    },
    reduceStopDay(index) {
      this.educational_institution_closing_day_list.splice(index, 1)
    },
    getBaseInfo() {
      this.selectTime[1] = ''
      this.selectTime[2] = ''
      this.selectTime[3] = ''
      this.selectTime[4] = ''
      this.selectTime[5] = ''
      this.selectTime[6] = ''
      this.selectTime[0] = ''
      this.selectTime[99] = ''

      getBaseInfo().then((res) => {
        console.log('获得校区基础排课信息1')
        console.log(res)

        this.is_encryption = res.educational_institution_obj[0].is_encryption
        this.selectTimeList1 = res.educational_institution_class_day_list

        this.closing_day = []
        this.educational_institution_closing_day_list =
          res.educational_institution_closing_day_list

        for (let key of res.educational_institution_closing_day_list) {
          this.closing_day.push(key.closing_date)
        }

        this.selectTimeList = []

        for (let key of res.educational_institution_class_day_list) {
          this.selectTimeList.push(
            `${key.start_class_date.slice(0, 5)}~${key.end_class_date.slice(
              0,
              5
            )}`
          )
        }

        this.$forceUpdate()
      })
    },

    goBack() {
      // this.$router.go(-1)
      this.$router.push({
        name: 'divide-class1',
        query: {
          paike: 'second',
          curriculum_class_type: this.$route.query.curriculum_class_type,
          id: this.$route.query.id,
          campus_id: this.$route.query.campus_id,
          curriculum_id: this.$route.query.curriculum_id,
          subject_id: this.$route.query.subject_id,
          is_cost_lesson_hour: this.$route.query.is_cost_lesson_hour,
          lesson_hour: this.$route.query.lesson_hour,
          classXmGoodsArr: this.$route.query.classXmGoodsArr,
          lecturer_id: this.$route.query.lecturer_id,
        },
      })
    },

    DeletePlan(row) {
      console.log(row)
      for (let k = 0; k < this.curriculumMaterialList.length; k++) {
        if (this.curriculumMaterialList[k].id == row.id) {
          this.curriculumMaterialList.splice(k, 1)
        }
      }
    },

    DeleteNotStartedPlan(row) {
      this.$confirm('确定要移除该讲次吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        for (let k = 0; k < this.NotStartedCourse.length; k++) {
          if (this.NotStartedCourse[k].id == row.id) {
            this.NotStartedCourse.splice(k, 1)
          }
        }
      })
    },

    ReChoice() {
      this.$confirm('确定恢复默认讲次?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.getPrepareCurrculumMaterialList()
      })
    },

    EditNotStartPlan() {
      console.log('未上课讲次,重新排课')
      console.log(this.teaching_plan_list)

      this.show_edit_plan = true
      this.NotStartedCourse = []

      for (let k = 0; k < this.teaching_plan_list.length; k++) {
        if (this.teaching_plan_list[k].sign_state == '2') {
          var plan = {
            id: this.teaching_plan_list[k].id,
            title: this.teaching_plan_list[k].lessionInfo.title,
          }

          this.NotStartedCourse.push(plan)
        }
      }
      console.log('所有未签到讲次')
      console.log(this.NotStartedCourse)
    },

    BackPlan() {
      this.show_edit_plan = false
    },

    //更新了上课时段
    UpdateTimes() {
      console.log('上课时段更新')
      this.getBaseInfo()
    },
  },
}
</script>
<style>
.ghostClass {
  background: #d9dee4 !important;
}

.chosenClass:hover > td {
  background: #d9dee4 !important;
}
</style>

<style lang="scss" scoped>
.courseArranging {
  .section {
    box-sizing: border-box;
    margin: 10px;
    padding: 15px 15px 15px 15px;
    border-radius: 5px;
    background-color: #fff;

    .arrang_btn {
      margin-bottom: 20px;
    }

    .classdate {
      margin-top: 20px;

      .classdate_start {
        font-weight: 500;
      }

      .classdate_stop {
        font-weight: 500;
      }
    }

    .hint {
      margin-left: 30px;
      font-size: 14px;
      color: red;
    }

    .time-frame {
      background-color: #f7f8fa;
      margin: 20px 0 0 20px;
      padding: 20px 0;
      border-radius: 5px;

      .frame {
        display: flex;
        align-items: center;
        border-radius: 5px;

        .title {
          font-size: 14px;
          margin-left: 20px;
        }

        .time {
          margin-left: 20px;
        }
      }
    }

    .btn {
      margin: 20px 0 0 20px;
    }

    .dialog {
      padding-bottom: 20px;
    }
  }
}
</style>
